// extracted by mini-css-extract-plugin
export default {"title":"TGv9l23jUa9chy51CyqQ","subtitle":"MlUhuIyw7e45gVy_kpmP","btn":"yHxlgcpljjA0Z2XmAwEA"};